import { ungzip } from 'pako';
import base85 from '@alttiri/base85';
import { WSSimpleClient } from './wssimple';

//TODO: after using share runtime we will get rid of this separation. Now formulas use Trident engine and don't support a lot js features
class WSClient extends WSSimpleClient {
  constructor() {
    super();

    this._decompress = (data) => {
      data = base85.decode(data);
      data = ungzip(data, { to: 'string' });
      return data;
    }
  }
}

const ws = new WSClient();
export { ws }